import { render, staticRenderFns } from "./base-dropdown.vue?vue&type=template&id=648dbeb5&scoped=true&"
import script from "./base-dropdown.vue?vue&type=script&lang=js&"
export * from "./base-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./base-dropdown.vue?vue&type=style&index=0&id=648dbeb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648dbeb5",
  null
  
)

export default component.exports